// Centralized environment resolution for browser bundlers
// Supports Vite-style import.meta.env and Bun browser env via process.env.BUN_PUBLIC_*

type AnyEnv = any;
const viteEnv: AnyEnv = (typeof import.meta !== 'undefined' ? (import.meta as AnyEnv).env : undefined);

const fromVite = (key: string) => viteEnv?.[key];
const fromBunPublic = (key: string) => (typeof process !== 'undefined' ? (process as AnyEnv).env?.[`BUN_PUBLIC_${key}`] : undefined);

const isProduction = fromVite('MODE') === 'production';

export const API_BASE: string =
  fromVite('VITE_API_BASE_URL') ||
  fromBunPublic('API_BASE_URL') ||
  (isProduction ? '' : 'http://localhost:5291');

export const SIGNALR_URL: string =
  fromVite('VITE_SIGNALR_URL') ||
  fromBunPublic('SIGNALR_URL') ||
  `${API_BASE}/chartHub`;

export const SCANNER_SIGNALR_URL: string =
  fromVite('VITE_SCANNER_SIGNALR_URL') ||
  fromBunPublic('SCANNER_SIGNALR_URL') ||
  `${API_BASE}/scannerHub`;

export const TRADING_SIGNALR_URL: string =
  fromVite('VITE_TRADING_SIGNALR_URL') ||
  fromBunPublic('TRADING_SIGNALR_URL') ||
  `${API_BASE}/tradingHub`;

